import React from 'react'
import { orderBy } from 'lodash'
import { DateTime } from 'luxon'
import { Message, Table } from 'semantic-ui-react'

import { ChartOfAccount } from '@/components/ChartOfAccounts/chartOfAccount.slice'
import { TransactionCategory } from '@/features/reports/reports.slice'
import { TransactionCategoryRow } from '@/v2-features/admin/TransactionCategoriesTable'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'

interface Props {
  coa?: ChartOfAccount
  categories?: { [key: number]: TransactionCategory }
}

const ChartOfAccountsTable: React.FC<Props> = ({ coa, categories }) => {
  if (!categories) {
    return null
  }

  let categoriesSorted: TransactionCategory[] = []

  coa?.chartOfAccountCategories.forEach((c) => {
    if (categories[c.transactionCategoryId]) {
      categoriesSorted.push(categories[c.transactionCategoryId])
    }
  })

  // Sort by non-archived first, then by calendar year
  categoriesSorted = orderBy(
    categoriesSorted,
    ['archivedAt', 'name'],
    ['desc', 'asc']
  )

  return (
    <>
      {coa?.archivedAt && (
        <Message
          warning
          header="This Chart of Accounts is no longer active"
          content={`It was archived on ${DateTime.fromISO(
            coa?.archivedAt ?? ''
          ).toFormat(DATE_FORMATS_LUXON.DISPLAY_LONG)}`}
        />
      )}
      <Table compact basic>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>ID</Table.HeaderCell>
            <Table.HeaderCell>Category Name</Table.HeaderCell>
            <Table.HeaderCell>Account Type</Table.HeaderCell>
            <Table.HeaderCell>Financial Statement</Table.HeaderCell>
            <Table.HeaderCell>Date Added</Table.HeaderCell>
            <Table.HeaderCell>Customer Account Label</Table.HeaderCell>
            <Table.HeaderCell>Archived Date</Table.HeaderCell>
            <Table.HeaderCell>Edit</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {categoriesSorted.map((category, index) => {
            let addedOn = ''
            const coaCategory = coa?.chartOfAccountCategories.find(
              (c) => c.transactionCategoryId === category.id
            )

            if (coaCategory) {
              addedOn = DateTime.fromISO(coaCategory?.createdAt).toFormat(
                DATE_FORMATS_LUXON.DISPLAY_SHORT
              )
            }

            if (!category) {
              return null
            }

            return (
              <TransactionCategoryRow
                key={index}
                auxColumn={addedOn}
                category={category}
              />
            )
          })}
        </Table.Body>
      </Table>
    </>
  )
}

export default ChartOfAccountsTable
